export const css = {
    root: '_1SLmqIcC',
    copyright: '_21sqiLp-',
    selector: '_2URhz7kP',
    privacypolicy: '_2eje6mk7',
    disclaimer: 'xsh6jJAC',
    ' _key': 'apic-theme/apic/lcc-app/footer'
};
export default css;
